import assignErrorId from '@formative/lib/assignErrorId';
import log from '@formative/logger';
import shouldDropErrorReport from "./shouldDropErrorReport.js";
function logReactError(error, errorInfo, caughtBy) {
  if (shouldDropErrorReport(error)) {
    return;
  }
  log.error({
    err: error,
    id: assignErrorId(error),
    componentStack: errorInfo.componentStack,
    caughtBy: caughtBy
  });
}
export default function reactRootErrorHandlers() {
  var handler = function handler(caughtBy) {
    return function (error, errorInfo) {
      return logReactError(error, errorInfo, caughtBy);
    };
  };
  return {
    onUncaughtError: handler('onUncaughtError'),
    onCaughtError: handler('onCaughtError'),
    onRecoverableError: handler('onRecoverableError')
  };
}